// Full-document render of the lookup-orders-by-email confirmation page:
// PageSkeleton wrapping LookupOrdersByEmailConfirmationPageBody.
import React from "react";

import { templates } from "@reactivated";

import { LookupOrdersByEmailConfirmationPageBody } from "../components/LookupOrdersByEmailConfirmationPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LookupOrdersByEmailConfirmationDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <LookupOrdersByEmailConfirmationPageBody />
        </PageSkeleton>
    );
};
